import React from "react";
import HikingIcon from "@mui/icons-material/Hiking";

//Types
import { SvgIconProps } from "@mui/material";

function StazaIcon(props: SvgIconProps) {
  return <HikingIcon {...props}/>;
}

export default StazaIcon;
